import * as React from 'react';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {
  ChipField,
  ReferenceManyField,
  SingleFieldList,
  useShowController,
} from 'react-admin';

export const DisplayListOfPostalCodes = (props: any) => {
  const { record } = useShowController(props);

  if (!record) {
    return <div>Loading...</div>;
  }

  return (
    <Box m={1}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Typography gutterBottom variant="subtitle1">
            Postal codes
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid alignContent="flex-end" container item xs={12}>
          <ReferenceManyField
            basePath="/PostalCode"
            label="Postal codes"
            perPage={400}
            record={record}
            reference="PostalCode"
            target="city_id"
          >
            <SingleFieldList linkType="edit">
              <ChipField source="postalCode" />
            </SingleFieldList>
          </ReferenceManyField>
        </Grid>
      </Grid>
    </Box>
  );
};
